export default "<span class=\"flag-icon\" [style]=\"style\"></span>\n";